var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "battery-store__wrapper" },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.showProductView ? _c("ProductView") : _vm._e(),
      _vm._v(" "),
      _vm.showShippingView ? _c("ShippingView") : _vm._e(),
      _vm._v(" "),
      _vm.showPaymentView ? _c("PaymentView") : _vm._e(),
      _vm._v(" "),
      _vm.showErrorView ? _c("ErrorMessageView") : _vm._e(),
      _vm._v(" "),
      _vm.showSuccessView ? _c("SuccessMessageView") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "battery-store__footer" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "css-grid battery-store__header" }, [
      _c("div", { staticClass: "battery-store__header-name" }, [
        _vm._v("Battery Order")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }